import { render } from "./PaymentRequestRefundList.vue?vue&type=template&id=00b2fe18&scoped=true"
import script from "./PaymentRequestRefundList.vue?vue&type=script&lang=ts"
export * from "./PaymentRequestRefundList.vue?vue&type=script&lang=ts"

import "./PaymentRequestRefundList.vue?vue&type=style&index=0&id=00b2fe18&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-00b2fe18"

export default script